import React from "react";
import { SFStack, SFGridContainer, SFGridItem } from "../grid";
import getStyled from "../../hooks/getStyled";
import SFTypography from "../typography";
import { SFToastAction } from "../toasts/toast";
import PropTypes from "prop-types";
import SFIconButton from "../button/iconButton";
import { SFCloseIcon } from "../icons";
const { styled } = getStyled();

const Wrappper = styled("div", {
  shouldForwardProp: (prop) => prop !== "isHovered",
})(({ theme, isHovered }) => ({
  paddingTop: "10px",
  paddingBottom: "10px",
  paddingLeft: "20px",
  paddingRight: "20px",
  borderBottom: `1px solid ${theme.palette.grey200.main}`,
  backgroundColor: isHovered ? theme.palette.blue50.main : "transparent",
}));

const SFTypographyStyledMessage = styled(SFTypography)(({ theme }) => ({
  fontSize: "12px",
}));

const SFTypographyStyledDate = styled(SFTypography)(({ theme }) => ({
  lineHeight: "19px",
}));

const SFNotification = ({ message, date, onClose, actionProps = {} }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const shouldRenderAction = Object.keys(actionProps).length > 0;
  return (
    <Wrappper
      onMouseOver={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      isHovered={isHovered}
    >
      <SFGridContainer
        alignItems={isHovered ? "center" : "flex-start"}
        justifyContent={"space-between"}
        spacing={1}
      >
        <SFGridItem xs={8.5}>
          <SFStack
            direction="column"
            alignItems={"flex-start"}
            justifyContent={"flex-start"}
            spacing={1}
          >
            <SFTypographyStyledMessage component="div" variant="pageActionBar">{message}</SFTypographyStyledMessage>
            {shouldRenderAction && (
              <SFToastAction
                label={actionProps.label}
                onClick={actionProps.onClick}
              />
            )}
          </SFStack>
        </SFGridItem>
        <SFGridItem xs="auto">
          {!isHovered ? (
            <SFTypographyStyledDate component="div" variant="tooltipText">{date}</SFTypographyStyledDate>
          ) : (
            <SFIconButton
              onClick={onClose}
              size="small"
              sx={{
                padding: "0px",
                width: "20px",
                height: "20px",
                "& .MuiSvgIcon-root": {
                  fontSize: "20px",
                },
              }}
            >
              <SFCloseIcon color="grey500"/>
            </SFIconButton>
          )}
        </SFGridItem>
      </SFGridContainer>
    </Wrappper>
  );
};

export default SFNotification;

SFNotification.propTypes = {
  /** The props for the notification action button. If not provided, the action button will not be displayed. */
  actionProps: PropTypes.shape({
    /** The label of the action button. */
    label: PropTypes.string,
    /** The function to call when the action button is clicked. */
    onClick: PropTypes.func,
  }),
  /** The message to display in the notification. */
  message: PropTypes.string,
  /** The date to display in the notification. */
  date: PropTypes.string,
  /** The function to call when the close icon button is clicked. */
  onClose: PropTypes.func,
};
